export const prependCountryCode = (
  mobileNumber,
  countryCode = '+966',
  prefix = '5',
) => {
  if (mobileNumber) {
    return `${countryCode}${prefix}${mobileNumber}`
  }
  return ''
}
